// Dashboard.jsx
import { useState, useEffect } from "react";
import SidebarUser from "../Component/SidebarUser";
import HeaderUser from "../../AdminPanel/Component/HeaderUser";
import { FaRobot } from "react-icons/fa6";

export default function Dashboard({
  children,
  userDetails,
  onLogout,
  getChatBookmarkData,
  selectChatBookMark,
  chatMarkIdInit,
  pageName,
  switchToAdmin,
  openAIBot,
  showBot
}) {

  console.log('userDetailsuserDetailsuserDetailsuserDetailsuserDetails', userDetails);

  const [collapsed, setCollapsed] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    const resize = () => {
      if (window.innerWidth < 768) setCollapsed(true);
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden relative">

      {/* SIDEBAR */}
      <SidebarUser
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        pageName={pageName}
        chatMarkIdInit={chatMarkIdInit}
        getChatBookmarkData={getChatBookmarkData}
        selectChatBookMark={selectChatBookMark}
        switchToAdmin={switchToAdmin}
      />

      {/* MAIN AREA */}
      <div className={`flex flex-col flex-1 transition-all duration-300 ml-0 ${collapsed ? "md:ml-20" : "md:ml-64"}`}>
        <HeaderUser
          collapsed={collapsed}
          toggleSidebar={toggleSidebar}
          userDetails={userDetails}
          onLogout={onLogout}
        />
        <main className="flex-1 overflow-y-auto mt-20 bg-white">
          {children}
        </main>
      </div>

      {/* ✅ RIGHT SIDE FLOATING BOAT ICON */}
      {showBot &&
        <div onClick={openAIBot} className="fixed bottom-6 right-6 z-50">
          <button
            className="
            w-14 h-14
            flex items-center justify-center
            rounded-full
            bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white
            shadow-lg
            hover:scale-110
            hover:bg-blue-600
            transition-all duration-300
          "
          >
            <span class=" material-symbols-outlined text-[1.5rem] ">
              auto_awesome
            </span>
          </button>
        </div>
      }


    </div>
  );
}